<template>
    <div class="padding">
        <div class="list-block">
            <div class="list-title">
                <img src="@/assets/images/bookFee@3x.png" width="32pt" style="vertical-align: middle;">
                <span>台北市路邊臨時停車費</span>
            </div>

            <div class="dark-card" style="margin: 5pt 0 0 0;">
                <div v-for="(item,i) in paymentList.parking" :key="i">
                    <div class="flex border" @click="changeShowChildren(item)">
                        <div style="display: flex;align-items: center">
                            <div class="agree-label">
                                <input type="checkbox" :id="item.id" @click="checkItemAll(item)"
                                       v-model="item.checked" :indeterminate.prop="item.indeterminate">
                                <label :for="item.id"></label>
                            </div>
                            <div>
                                <div>{{item.id}}</div>
                                <div style="font-size: 14px;color: #c7c7c7;">{{item.type}}</div>
                            </div>
                        </div>
                        <div class="delete" v-if="modify"></div>
                        <div class="price" style="display: flex" v-else>
                            <span style="margin-right: 5px;">${{item.price}}</span>
                            <div class="hidden"></div>
                        </div>
                    </div>
                    <div class="children" v-show="item.is_show_children">
                        <div v-for="(child,j) in item.children" :key="j" class="flex">
                            <div style="display: flex;align-items: center;">
                                <div class="agree-label">
                                    <input type="checkbox" :id="child.id" v-model="child.checked" @click="checkChildItem(item,child)">
                                    <label :for="child.id"></label>
                                </div>
                                <div>
                                    <div class="text-gray1">{{child.id}}</div>
                                    <div class="text-gray2">停車日期：{{child.date}}</div>
                                    <div class="text-gray2">繳費期限：{{child.period}}</div>
                                </div>
                            </div>
                            <div>${{child.price}}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!--<div class="list-block">
            <img src="@/assets/images/iconEsayWallet@3x.png" width="32pt" style="vertical-align: middle;">
            <span>擴充項目</span>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "payment-binding-list",
        props: {
            paymentList: {

            },
            modify:{}
        },
        mounted() {
            (this.paymentList.parking).forEach(el => {
                this.$set(el, 'is_show_children', false);
                this.$set(el, 'checked', false);
                this.$set(el, 'indeterminate', false);
                el.children.forEach(n => {
                    this.$set(n, 'checked', false);
                })
            })
        },
        data() {
            return {

            }
        },
        methods: {
            changeShowChildren(item) {
                item.is_show_children = !item.is_show_children;
            },
            checkItemAll(item){
                item.checked = !item.checked;
                item.children.forEach(child=>{
                    child.checked = item.checked;
                });
            },
            checkChildItem(item,child){
                child.checked = !child.checked;

                if(item.children.every(child=>{return child.checked;})){
                    item.checked = true;
                    item.indeterminate = false;
                }else{
                    item.checked = false;
                    item.indeterminate = item.children.some(child=>{
                        return child.checked;
                    });
                }
            },
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    .dark-card {
        padding: 0;
    }

    .dark-card .flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 9pt 10pt;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    .field {
        margin: 10px 0;
    }

    .list-block {
        margin-top: 20px;

        .list-title {
            display: flex;
            align-items: center;
        }
    }

    .children {
        background: rgba(255, 255, 255, 0.9);
        color: #404040;
    }

    .text-gray2 {
        font-size: 12px;
    }
</style>
